<template>
  <div class="weight-loss-knowledge">
    <Banner :title="title" />
    <div class="container">
      <h1>减肥基础知识</h1>
      
      <div class="section">
        <h2>什么是健康减肥？</h2>
        <p>健康减肥是指通过合理的饮食和适当的运动方式，以健康的速度减轻体重，同时保持身体的健康状态。健康减肥应当是可持续的，不应该急于求成。通常来说，每周减重0.5-1公斤是较为合理的减肥速度。</p>
        <div class="img-container">
          <img src="../assets/img/product_group_3_img.png" alt="健康减肥">
        </div>
      </div>
      
      <div class="section">
        <h2>科学减肥的基本原则</h2>
        <ul>
          <li><strong>控制热量摄入：</strong>减少高热量、高脂肪、高糖分食物的摄入，增加蔬果、全谷类和优质蛋白质的比例。</li>
          <li><strong>合理安排运动：</strong>结合有氧运动（如慢跑、游泳、骑自行车）和力量训练，提高基础代谢率。</li>
          <li><strong>规律作息：</strong>保持充足的睡眠，减少熬夜，有助于代谢正常运行。</li>
          <li><strong>控制情绪：</strong>避免情绪化饮食，学会应对压力的健康方式。</li>
          <li><strong>喝足够的水：</strong>每天保持足够的水分摄入，促进新陈代谢和排毒。</li>
        </ul>
      </div>
      
      <div class="section">
        <h2>常见的减肥误区</h2>
        <div class="misconception">
          <h3>误区一：节食是减肥的最佳方式</h3>
          <p>过度节食会导致身体进入"饥饿模式"，降低基础代谢率，使减肥更加困难。同时，严格的节食计划往往难以坚持，容易导致反弹。</p>
        </div>
        <div class="misconception">
          <h3>误区二：运动越多越好</h3>
          <p>过度运动可能导致身体受伤或疲劳，影响正常代谢和生活质量。适量且持续的运动才是关键。</p>
        </div>
        <div class="misconception">
          <h3>误区三：减肥产品可以轻松瘦身</h3>
          <p>市场上许多减肥产品缺乏科学依据，甚至可能含有有害成分。健康减肥需要综合调整生活方式，没有捷径。</p>
        </div>
      </div>
      
      <div class="section">
        <h2>健康饮食指南</h2>
        <div class="diet-tips">
          <h3>营养均衡</h3>
          <p>保证摄入足够的蛋白质、碳水化合物、健康脂肪、维生素和矿物质，以维持身体正常功能。</p>
        </div>
        <div class="diet-tips">
          <h3>控制份量</h3>
          <p>使用小一些的餐盘，细嚼慢咽，避免暴饮暴食。</p>
        </div>
        <div class="diet-tips">
          <h3>合理安排餐次</h3>
          <p>少食多餐可以帮助控制饥饿感和血糖水平，避免过度进食。</p>
        </div>
      </div>
      
      <div class="section">
        <h2>推荐的运动方式</h2>
        <div class="exercise-types">
          <h3>有氧运动</h3>
          <p>如慢跑、快走、骑自行车、游泳等，有助于燃烧脂肪。建议每周进行至少150分钟的中等强度有氧运动。</p>
        </div>
        <div class="exercise-types">
          <h3>力量训练</h3>
          <p>如举重、俯卧撑、深蹲等，有助于增加肌肉质量，提高基础代谢率。建议每周进行2-3次力量训练。</p>
        </div>
        <div class="exercise-types">
          <h3>柔韧性训练</h3>
          <p>如瑜伽、普拉提等，有助于改善身体灵活性和平衡能力。</p>
        </div>
      </div>
      
      <div class="section">
        <h2>减肥成功的关键</h2>
        <p>减肥不仅仅是短期行为，而是一种生活方式的改变。持续性和耐心是成功减肥的关键。找到适合自己的健康饮食和运动方式，并长期坚持下去，才能达到理想的效果。</p>
        <div class="img-container">
          <img src="../assets/img/home_do.jpg" alt="健康生活方式">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Banner from "../components/Banner";

export default {
  name: "WeightLossKnowledge",
  components: {
    Banner
  },
  data() {
    return {
      title: "减肥知识"
    };
  }
};
</script>

<style lang="scss" scoped>
.weight-loss-knowledge {
  width: 100%;
  
  .container {
    width: 1240px;
    margin: 0 auto;
    padding: 40px 20px;
    
    h1 {
      font-size: 32px;
      color: #01579b;
      text-align: center;
      margin-bottom: 40px;
    }
    
    .section {
      margin-bottom: 50px;
      
      h2 {
        font-size: 26px;
        color: #0288d1;
        margin-bottom: 20px;
        padding-bottom: 10px;
        border-bottom: 2px solid #e0e0e0;
      }
      
      p {
        font-size: 16px;
        line-height: 1.8;
        color: #333;
      }
      
      ul {
        padding-left: 20px;
        
        li {
          margin-bottom: 15px;
          font-size: 16px;
          line-height: 1.8;
        }
      }
      
      .img-container {
        margin: 30px 0;
        text-align: center;
        
        img {
          max-width: 80%;
          border-radius: 8px;
          box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
        }
      }
      
      .misconception, .diet-tips, .exercise-types {
        background-color: #e3f2fd;
        padding: 20px;
        border-radius: 8px;
        margin-bottom: 20px;
        
        h3 {
          font-size: 20px;
          color: #01579b;
          margin-bottom: 10px;
        }
        
        p {
          font-size: 16px;
        }
      }
    }
  }
}

@media screen and (max-width: 1240px) {
  .weight-loss-knowledge {
    .container {
      width: 100%;
    }
  }
}
</style>
